// revision.js — aviso amarillo cuando se presta / devuelve / prepara una
// llave (o un piso) MARCADA PARA REVISIÓN 🚩.
// `rev` es lo que devuelve el backend:
//   {llave, nota_llave, piso, nota_piso, llave_id, piso_id}

import api from "./setupAxios";

export function textoRevision(rev, etiquetaLlave, etiquetaPiso) {
  if (!rev) return null;
  const partes = [];
  if (rev.llave) partes.push(`La llave ${etiquetaLlave} está marcada para revisión.\nMotivo: ${rev.nota_llave || "(sin motivo escrito)"}`);
  if (rev.piso) partes.push(`El piso ${etiquetaPiso} está marcado para revisión.\nMotivo: ${rev.nota_piso || "(sin motivo escrito)"}`);
  return partes.join("\n\n");
}

// Muestra el aviso y espera la decisión. Los botones "Desmarcar llave / piso"
// son interruptores: NO desmarcan al pulsarlos, solo indican que se desmarque
// cuando se haga de verdad la operación (el backend lo hace en la misma
// transacción). Si se cancela, o la operación no llega a hacerse, la marca
// se queda. Devuelve
//   {seguir, desmarcar_llave, desmarcar_piso, sigueMarcada}
//   const r = await pedirConfirmacionRevision(alertaRevision, rev, {accion: "prestar", ...});
//   if (!r.seguir) return;   // y mandar r.desmarcar_llave / r.desmarcar_piso a la API
export async function pedirConfirmacionRevision(alertaRevision, rev, { accion, etiquetaLlave, etiquetaPiso }) {
  const desmarcar = [];
  if (rev.llave) desmarcar.push({ clave: "llave", texto: "Desmarcar llave", hecho: `La llave se desmarcará al ${accion}la` });
  if (rev.piso) desmarcar.push({ clave: "piso", texto: "Desmarcar piso", hecho: `El piso se desmarcará al ${accion}la` });
  const r = await alertaRevision(textoRevision(rev, etiquetaLlave, etiquetaPiso), {
    titulo: rev.llave ? `Vas a ${accion} una llave marcada para revisión` : `Vas a ${accion} una llave de un piso marcado para revisión`,
    pregunta: `¿Quieres ${accion}la igualmente?`,
    boton: `Sí, ${accion}`,
    desmarcar,
  });
  const elegidos = r?.elegidos || [];
  const desmarcar_llave = !!rev.llave && elegidos.includes("llave");
  const desmarcar_piso = !!rev.piso && elegidos.includes("piso");
  return { seguir: !!r?.seguir, desmarcar_llave, desmarcar_piso,
           sigueMarcada: (!!rev.llave && !desmarcar_llave) || (!!rev.piso && !desmarcar_piso) };
}

const MOTIVOS_DEVOLVER = {
  piso_no_existe: "Ese piso no existe o está de baja.",
  no_prestada: "Esa llave no consta como prestada.",
  reaparecida: "Esa llave está dada de baja (perdida): reactívala en Inventario (↩️) o devuélvela desde Gestionar > Devolver.",
};

// Registra una devolución (POST /devolver) fuera de Gestionar (p.ej. Contar
// cajetines), pasando por el aviso amarillo si la llave/piso está marcado 🚩.
// Devuelve {ok:true, data} | {ok:false, cancelado:true} | {ok:false, error}.
// extra: p.ej. {mov_id} para devolver el préstamo concreto de una llave sin número.
export async function devolverConAvisoRevision(alertaRevision, piso, cod, extra = {}) {
  let body = { piso: String(piso), cod: String(cod), ...extra };
  for (;;) {
    const { data } = await api.post("/devolver", body);
    if (data.motivo === "revision" && !body.confirmado_revision) {
      const r = await pedirConfirmacionRevision(alertaRevision, data.revision,
        { accion: "devolver", etiquetaLlave: `${data.id_piso}-${cod}`, etiquetaPiso: data.codigo });
      if (!r.seguir) return { ok: false, cancelado: true };
      body = { ...body, confirmado_revision: true, desmarcar_llave: r.desmarcar_llave, desmarcar_piso: r.desmarcar_piso };
      continue;
    }
    if (data.ok) return { ok: true, data };
    return { ok: false, error: data.error || MOTIVOS_DEVOLVER[data.motivo] || "No se pudo registrar la devolución." };
  }
}
